const config = {
    apiBaseUrl: 'https://dodigitals.in/dodigitalseducation/public/api/'
  };
  
  export default config;